import { FunctionComponent } from "react";

import { ApiCallButton } from "@components/buttons/ApiCallButton";
import { useRepairFederatedUserAccounts } from "@libs/api/gateways/bp-id/bp-id.hooks";

export interface RepairFederatedUserAccountsButtonProps {
  bpIdUserId: string;
}
export const RepairFederatedUserAccountsButton: FunctionComponent<RepairFederatedUserAccountsButtonProps> = ({
  bpIdUserId
}) => {
  const {
    mutateAsync: repair,
    isLoading,
    error
  } = useRepairFederatedUserAccounts();

  return (
    <ApiCallButton
      isLoading={isLoading}
      error={error}
      onClick={() => {
        repair(bpIdUserId);
      }}
    >
      Repair
    </ApiCallButton>
  );
};
